module.exports = __webpack_public_path__ + "img/xcx.15a54896.svg";